// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"company-form_tabContent_3u8ph"};